module.exports = __webpack_public_path__ + "assets/images/drink_g.1e882e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/drink_g.png
// module id = 703
// module chunks = 1